import { SupportedChainId } from '../connectors/index'
type AddressMap = { [chainId: number]: string }
export const SANDZ_NFT_ADDRESS: AddressMap = {
    [SupportedChainId.MAINNET]: '0x5FbDB2315678afecb367f032d93F642f64180aa3',
    [SupportedChainId.RINKEBY]: '0x18390739C9E024D7A574B275573E664b7A2C3EEe',
    [SupportedChainId.HARDHAT]: '0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512',
}
export const DISCORD_LINK = "https://discord.gg/sandzsociety";
export const TWITTER_LINK = "https://twitter.com/SandzSociety";
export const INSTAGRAM_LINK = "https://www.instagram.com/sandzsociety";
export const FACEBOOK_LINK ="";
export const MAX_SUPPLY = 10000;
export const START_TIME = new Date(2022, 2 - 1, 28, 22, 30).valueOf();
export const MINT_PRICE = 0.3;